import { AlertTriangle, AlertOctagon, CheckCircle2, RefreshCw } from "lucide-react";
import { S, MANROPE, FOCUS } from "./lib";

/* The findings, read as sentences rather than rule codes, sitting where someone
   will read them before approving. Blockers first. */
export default function SocialFlags({ flags = [], checkedAt, onRecheck, checking }) {
  const blocks = flags.filter((f) => f.severity === "block");
  const warns = flags.filter((f) => f.severity !== "block");
  const checked = !!checkedAt;

  const Row = ({ f, hard }) => (
    <div className="rounded-[8px] px-3 py-2.5 flex items-start gap-2 text-[12.5px]"
      data-testid={`social-flag-${f.code}`}
      style={hard
        ? { background: "#FFF1EC", border: "1px solid #F0C4B4", color: "#8E3A12" }
        : { background: "#FFF8D6", border: "1px solid #E8D48A", color: S.accentInk }}>
      {hard ? <AlertOctagon className="w-4 h-4 shrink-0 mt-0.5" />
        : <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />}
      <span>{f.message}</span>
    </div>
  );

  return (
    <div className="rounded-[10px] p-3.5 space-y-2.5" data-testid="social-flags"
      style={{ background: S.card, border: `1px solid ${blocks.length ? "#F0C4B4" : S.border}` }}>
      <div className="flex items-center gap-2">
        <div style={{ ...MANROPE, fontSize: 13.5, fontWeight: 700, color: S.ink }}>
          House rules
        </div>
        <span className="text-[11.5px]" style={{ color: S.ink3 }} data-testid="social-flags-count">
          {!checked ? "not checked yet"
            : blocks.length > 0
              ? `${blocks.length} to fix before this can be approved`
              : warns.length > 0 ? `${warns.length} worth a look` : "nothing found"}
        </span>
        {onRecheck && (
          <button onClick={onRecheck} disabled={checking} data-testid="social-flags-recheck"
            className={`ml-auto inline-flex items-center gap-1 text-[11px] font-bold uppercase ${FOCUS}`}
            style={{ color: S.accentInk, letterSpacing: "0.04em" }}>
            <RefreshCw className={`w-3 h-3 ${checking ? "animate-spin" : ""}`} /> Check again
          </button>
        )}
      </div>

      {blocks.length === 0 && warns.length === 0 ? (
        !checked ? (
          <div className="text-[12.5px]" style={{ color: S.ink2 }} data-testid="social-flags-unchecked">
            The rules have not run over this post yet — check it, or make any change and they run
            themselves.
          </div>
        ) : (
          <div className="flex items-center gap-2 text-[12.5px]" style={{ color: S.good }}
            data-testid="social-flags-clear">
            <CheckCircle2 className="w-4 h-4" /> Nothing breaches the house rules.
          </div>
        )
      ) : (
        <div className="space-y-2">
          {blocks.map((f, i) => <Row key={`b${i}`} f={f} hard />)}
          {warns.map((f, i) => <Row key={`w${i}`} f={f} />)}
        </div>
      )}
    </div>
  );
}
